import axios, { type AxiosRequestConfig } from 'axios'

export abstract class AbstractApiService {
  protected abstract getDsn(): string

  public get(resource: string, config?: AxiosRequestConfig) {
    return axios.request({ ...config, url: this.getUrl(resource), method: 'GET', headers: this.getHeaders() })
  }

  public post(resource: string, payload: Record<string, unknown>) {
    return axios.request({
      method: 'POST',
      url: this.getUrl(resource),
      responseType: 'json',
      data: payload,
      headers: this.getHeaders(),
    })
  }

  public put(resource: string, payload: Record<string, unknown>) {
    return axios.request({
      method: 'PUT',
      url: this.getUrl(resource),
      responseType: 'json',
      data: payload,
      headers: this.getHeaders(),
    })
  }

  public delete(resource: string) {
    return axios.request({
      method: 'DELETE',
      url: this.getUrl(resource),
      responseType: 'json',
      headers: this.getHeaders(),
    })
  }

  protected getHeaders() {
    return {}
  }

  private getUrl(resource: string) {
    if (resource.includes('http')) {
      return resource
    }
    return `${this.getDsn()}${resource}`
  }

  // private handleSuccess(response) {
  //   return response
  // }

  // private handleError(error) {
  //   switch (error.response.status) {
  //     case 404: {
  //       console.log('Error 404')
  //       this.redirectTo(document, '/404')
  //       break
  //     }
  //     case 422: {
  //       console.log('Error 422')
  //       break
  //     }
  //     case 500: {
  //       console.log('Error 500')
  //       this.redirectTo(document, '/500')
  //       break
  //     }
  //     default:
  //     // do nothing
  //   }
  //   return Promise.reject(error)
  // }

  // redirectTo(document, path) {
  //   document.location = path
  // }
}
